module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_hanna-liukkonen_A4.4c2af8c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_hanna-liukkonen_A4.pdf
// module id = x8Rr
// module chunks = 22